import { omit } from 'lodash';

export default ['$http', '$rootScope', '$location', 'Upload', function ($http, $rootScope, $location, Upload) {
    const defaultConfig = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    };

    const buildUrl = url => `//${$location.host()}${url}`;

    const makeRequest = (method, url, data, config = defaultConfig) => {
        config = Object.assign({}, defaultConfig, config);

        url = buildUrl(url);

        data = data ? omit(data, ['uuid', 'id', '_embedded', '_links']) : data;

        return data ?
            method(url, data, config) :
            method(url, config);
    };

    const upload = (url, data) => {
        if (data.id || data.user_id) {
            data._method = 'PUT';
        }

        const request = {
            url: buildUrl(url),
            data: data,
            method: 'POST'
        };

        return Upload.upload(request);
    };

    return {
        property: () => ($rootScope.currentProperty ? $rootScope.currentProperty.id : 0),
        get: (url, config) => makeRequest($http.get, url, null, config),
        post: (url, data) => makeRequest($http.post, url, data),
        upload: (url, data) => upload(url, data),
        put: (url, data) => makeRequest($http.put, url, data),
        patch: (url, data) => makeRequest($http.patch, url, data),
        delete: (url) => makeRequest($http.delete, url),
        buildUrl
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/services/api.service.js